import React from "react";
import styles from "./admin.module.scss";
import cx from "./cx";

export type BadgeTone =
  | "mint"
  | "gold"
  | "blue"
  | "rose"
  | "grey"
  | "lilac"
  | "dark";

const toneClass: Record<BadgeTone, string> = {
  mint: styles.bMint,
  gold: styles.bGold,
  blue: styles.bBlue,
  rose: styles.bRose,
  grey: styles.bGrey,
  lilac: styles.bLilac,
  dark: styles.bDark,
};

interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  tone = "grey",
  className,
  children,
}) => (
  <span className={cx(styles.badge, toneClass[tone], className)}>
    {children}
  </span>
);

export default Badge;
